// extracted by mini-css-extract-plugin
export default {"link":"CustomNavLink_link__dhHmq","default":"CustomNavLink_default__QouD5","active":"CustomNavLink_active__7WeG3"};